(() => {
  const initialize = (scope) => {
    scope.querySelectorAll('[data-vp-product]').forEach((root) => {
      if (root.dataset.initialized) return;
      const variantData = root.querySelector('[data-variant-data]');
      const stringData = root.querySelector('[data-product-strings]');
      if (!variantData || !stringData) return;
      let variants;
      let strings;
      try {
        variants = JSON.parse(variantData.textContent);
        strings = JSON.parse(stringData.textContent);
      } catch {
        return;
      }
      const select = root.querySelector('[data-variant-select]');
      const quantity = root.querySelector('[data-quantity-input]');
      const addButton = root.querySelector('[data-add-button]');
      if (!select || !quantity || !addButton) return;
      root.dataset.initialized = 'true';
      const buttons = root.querySelector('[data-variant-buttons]');
      const form = root.querySelector('form');
      const bundle = root.querySelector('[data-bundle]');
      const bundleAddButton = root.querySelector('[data-bundle-add-button]');
      const purchaseButtons = [addButton, bundleAddButton].filter(Boolean);
      const tierButtons = root.querySelectorAll('[data-bundle-tier]');
      const dynamicCheckout = root.querySelector('[data-dynamic-checkout]');
      const feedback = root.querySelector('[data-cart-message]');
      let submitting = false;
      const currentVariant = () => variants.find((item) => String(item.id) === select.value);
      const currency = root.dataset.currency || 'USD';
      const formatter = new Intl.NumberFormat(root.dataset.locale || 'en-US', { style: 'currency', currency });
      const money = (cents) => formatter.format(cents / 100);
      const setText = (selector, value) => {
        const node = root.querySelector(selector);
        if (node) node.textContent = value;
      };
      const permittedQuantity = (variant, amount) => amount >= variant.minimum && (amount - variant.minimum) % variant.increment === 0 && (!variant.maximum || amount <= variant.maximum);
      const normalizeQuantity = (variant) => {
        quantity.min = String(variant.minimum);
        quantity.step = String(variant.increment);
        if (variant.maximum) quantity.max = String(variant.maximum);
        else quantity.removeAttribute('max');
        let amount = Math.max(variant.minimum, Number(quantity.value) || variant.minimum);
        amount = variant.minimum + Math.ceil((amount - variant.minimum) / variant.increment) * variant.increment;
        if (variant.maximum) {
          const allowedMaximum = variant.minimum + Math.floor((variant.maximum - variant.minimum) / variant.increment) * variant.increment;
          amount = Math.min(amount, allowedMaximum);
        }
        quantity.value = String(amount);
        return amount;
      };
      const showMedia = (id) => {
        const target = root.querySelector('[data-media-id="' + id + '"]');
        if (!target) return;
        root.querySelectorAll('[data-media-id]').forEach((media) => {
          media.hidden = media !== target;
          if (media.hidden) media.querySelectorAll('video').forEach((video) => video.pause());
        });
        root.querySelectorAll('[data-media-select]').forEach((button) => {
          button.setAttribute('aria-pressed', String(button.dataset.mediaSelect === String(id)));
        });
      };
      const renderBundle = (variant, amount) => {
        if (!bundle) return true;
        let activeTier = null;
        tierButtons.forEach((button) => {
          const tierQuantity = Number(button.dataset.bundleTier);
          const percent = Number(button.dataset.tierPercent);
          const eligible = permittedQuantity(variant, tierQuantity);
          const selected = eligible && tierQuantity === amount;
          button.disabled = !eligible || !variant.available;
          button.setAttribute('aria-pressed', String(selected));
          const original = variant.price_cents * tierQuantity;
          const originalNode = button.querySelector('[data-tier-original]');
          const totalNode = button.querySelector('[data-tier-total]');
          if (originalNode) originalNode.textContent = money(original);
          if (totalNode) totalNode.textContent = money(original - Math.floor(original * percent / 100));
          if (selected) activeTier = { quantity: tierQuantity, percent };
        });
        const bundledAmount = activeTier ? amount : 0;
        const percent = activeTier ? activeTier.percent : 0;
        const original = variant.price_cents * bundledAmount;
        const total = original - Math.floor(original * percent / 100);
        setText('[data-bundle-count]', bundledAmount + '/' + bundledAmount);
        setText('[data-bundle-variant]', variant.title);
        setText('[data-bundle-item-quantity]', String(bundledAmount));
        setText('[data-bundle-line-total]', money(original));
        setText('[data-bundle-original]', money(original));
        setText('[data-bundle-total]', money(total));
        setText('[data-bundle-savings]', money(original - total));
        setText('[data-bundle-savings-percent]', '(' + percent + '%)');
        const progress = bundle.querySelector('[data-bundle-progress-fill]');
        if (progress) progress.style.width = activeTier ? '100%' : '0%';
        const imageWrap = root.querySelector('[data-bundle-image-wrap]');
        const image = imageWrap?.querySelector('img');
        if (image) {
          imageWrap.hidden = !variant.image;
          if (variant.image) {
            image.src = variant.image;
            image.removeAttribute('srcset');
            image.alt = variant.title;
          }
        }
        return Boolean(activeTier);
      };
      const renderPurchaseState = (variant, validBundle) => {
        addButton.disabled = submitting || !variant.available;
        if (submitting) addButton.textContent = strings.adding;
        else if (!variant.available) addButton.textContent = strings.sold_out;
        else addButton.textContent = strings.add;
        if (bundleAddButton) {
          bundleAddButton.disabled = submitting || !variant.available || !validBundle;
          if (submitting) bundleAddButton.textContent = strings.adding;
          else if (!variant.available) bundleAddButton.textContent = strings.sold_out;
          else bundleAddButton.textContent = validBundle ? strings.bundle_add : strings.choose_bundle;
        }
        if (dynamicCheckout) dynamicCheckout.hidden = !variant.available;
      };
      const updateQuantity = () => {
        const variant = currentVariant();
        if (!variant) return;
        const amount = normalizeQuantity(variant);
        renderPurchaseState(variant, renderBundle(variant, amount));
      };
      const updateVariant = (updateUrl = true) => {
        const variant = currentVariant();
        if (!variant) return;
        setText('[data-variant-price]', variant.price);
        const compare = root.querySelector('[data-variant-compare]');
        compare.textContent = variant.compare;
        compare.hidden = !variant.on_sale;
        root.querySelector('[data-variant-sale]').hidden = !variant.on_sale;
        root.querySelectorAll('[data-variant-button]').forEach((button) => {
          button.setAttribute('aria-pressed', String(button.dataset.variantButton === String(variant.id)));
        });
        updateQuantity();
        if (variant.media_id) showMedia(variant.media_id);
        if (updateUrl && !window.Shopify?.designMode) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', String(variant.id));
          window.history.replaceState({}, '', url);
        }
      };
      if (buttons) {
        buttons.hidden = false;
        select.hidden = true;
        root.querySelectorAll('[data-variant-button]').forEach((button) => {
          button.addEventListener('click', () => {
            select.value = button.dataset.variantButton;
            select.dispatchEvent(new Event('change', { bubbles: true }));
          });
        });
      }
      select.addEventListener('change', () => updateVariant());
      quantity.addEventListener('change', updateQuantity);
      tierButtons.forEach((button) => {
        button.addEventListener('click', () => {
          quantity.value = button.dataset.bundleTier;
          quantity.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
      root.querySelectorAll('[data-media-select]').forEach((button) => {
        button.addEventListener('click', () => showMedia(button.dataset.mediaSelect));
      });
      root.querySelectorAll('[data-quantity-change]').forEach((button) => {
        button.addEventListener('click', () => {
          const current = Number(quantity.value) || Number(quantity.min) || 1;
          const step = Number(quantity.step) || 1;
          let next = current + Number(button.dataset.quantityChange) * step;
          next = Math.max(Number(quantity.min) || 1, next);
          if (quantity.max) next = Math.min(Number(quantity.max), next);
          quantity.value = String(next);
          quantity.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
      if (form && typeof fetch === 'function') {
        form.addEventListener('submit', async (event) => {
          if (event.submitter && event.submitter.name !== 'add') return;
          event.preventDefault();
          if (submitting) return;
          updateQuantity();
          const variant = currentVariant();
          const submittedButton = event.submitter === bundleAddButton ? bundleAddButton : addButton;
          if (!variant || submittedButton.disabled) return;
          const amount = Number(quantity.value);
          submitting = true;
          purchaseButtons.forEach((button) => button.setAttribute('aria-busy', 'true'));
          renderPurchaseState(variant, true);
          if (feedback) feedback.hidden = true;
          try {
            const properties = {};
            new FormData(form).forEach((value, name) => {
              const property = name.match(/^properties\[([^\]]+)\]$/);
              if (property && typeof value === 'string') properties[property[1]] = value;
            });
            const response = await fetch(root.dataset.cartAddUrl || (window.Shopify?.routes?.root || '/') + 'cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items: [{ id: variant.id, quantity: amount, properties }] })
            });
            const data = await response.json();
            if (!response.ok) throw new Error(data.description || data.message || strings.cart_error);
            window.location.assign(root.dataset.cartUrl || (window.Shopify?.routes?.root || '/') + 'cart');
          } catch (error) {
            if (feedback) {
              feedback.textContent = error.message || strings.cart_error;
              feedback.hidden = false;
            }
          } finally {
            submitting = false;
            purchaseButtons.forEach((button) => button.removeAttribute('aria-busy'));
            updateQuantity();
          }
        });
      }
      updateVariant(false);
    });
  };
  initialize(document);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
